export default __webpack_public_path__ + "static/media/kyc-selfie-id.c434bf4a.svg";